export default __webpack_public_path__ + "885e52f53fc9f676423789c287ffccb9.svg";